import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { masterclassesAPI } from '../services/api';
import { MasterclassCard } from '../components/Card';
import './ListPage.css';

const CATEGORIES = ['Tech', 'Business', 'Finance', 'Marketing', 'Leadership', 'Développement personnel', 'Droit'];

export default function Masterclasses() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [meta, setMeta] = useState({});
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('');
  const [type, setType] = useState('');
  const [page, setPage] = useState(1);
  const [toast, setToast] = useState('');

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await masterclassesAPI.list({ search, category, type, page });
      setItems(data.data);
      setMeta(data.meta);
    } catch {}
    finally { setLoading(false); }
  }, [search, category, type, page]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const handleEnroll = async (item) => {
    if (!user) { window.location.href = '/login'; return; }
    try {
      const { data } = await masterclassesAPI.enroll(item.id);
      setToast(data.message);
    } catch (err) {
      setToast(err.response?.data?.message || 'Erreur lors de l\'inscription.');
    }
  };

  return (
    <div className="list-page">
      <div className="page-header">
        <h1>Savoirs</h1>
        <p>Le savoir qui circule dans l'écosystème YesNeDni — sélectionné par nos alumni.</p>
      </div>

      <div className="filters">
        <input
          type="text"
          placeholder="Rechercher une formation..."
          value={search}
          onChange={(e) => { setSearch(e.target.value); setPage(1); }}
          className="search-input"
        />
        <select value={category} onChange={(e) => { setCategory(e.target.value); setPage(1); }} className="filter-select">
          <option value="">Toutes catégories</option>
          {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
        <select value={type} onChange={(e) => { setType(e.target.value); setPage(1); }} className="filter-select">
          <option value="">Gratuit & Payant</option>
          <option value="gratuit">Gratuit</option>
          <option value="premium">Payant</option>
        </select>
      </div>

      {loading ? (
        <div className="loading">Chargement...</div>
      ) : items.length === 0 ? (
        <div className="empty">Aucun contenu trouvé.</div>
      ) : (
        <div className="grid-3">
          {items.map((item) => (
            <MasterclassCard key={item.id} item={item} onEnroll={handleEnroll} />
          ))}
        </div>
      )}

      {meta.last_page > 1 && (
        <div className="pagination">
          {Array.from({ length: meta.last_page }, (_, i) => i + 1).map((p) => (
            <button key={p} onClick={() => setPage(p)} className={`page-btn ${p === page ? 'active' : ''}`}>{p}</button>
          ))}
        </div>
      )}

      {toast && <div className="toast" onClick={() => setToast('')}>{toast}</div>}
    </div>
  );
}
